<template>
  <div class="maintenance-wrap d-flex align-items-center">
    <div class="container">
      <div class="text-center">
        <div class="row justify-content-center">
          <div class="col-md-8 px-5">
            <img
              src="img/true_dtac.png"
              alt=""
              style="width:50%;height:auto;"
            />

            <h1 class="mt-5">{{ $t("maintenance.title") }}</h1>
            <p class="text-lead">{{ $t("maintenance.description") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "maintenance-page"
};
</script>

<style scoped>
/* Fill the available viewport height (minus footer ~15vh) so the content
   can vertically center within the page instead of being pinned to the
   top edge. */
.maintenance-wrap {
  min-height: 85vh;
}
</style>
